import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import domConstruct from 'dojo/dom-construct';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import MandatoryNotification from '../MandatoryNotification/MandatoryNotification';
// NOTE (JS2TS): dropped dead dep dojo/_base/lang (imported but unused).

interface _MandatoryMixin { }
export default function _MandatoryMixin(__Base: any) {
  const __C = 
class _MandatoryMixin extends __Base {
    [key: string]: any;

    mandatory;
    valid;
    _mandatoryNotification: any;
    mandatoryNodeName;
    mandatoryNodePosition;
    mandatoryInfoText: any;
    dateOverMaxLimit;

    checkValidity() {
        this._checkValidity(); // alias
    }

    _setMandatoryAttr(mandatory: any) {
        this.mandatory = mandatory;
    }

    _getMandatoryAttr() {
        return this.mandatory;
    }

    _checkValidity() {
        if (this.mandatory == false) return true;

        var valid = true;

        if (this.get("value") == null) {
            valid = false;
        }

        this.valid = valid;

        this._showValidState();
        return valid;
    }

    validateInput() {
        this._checkValidity(); // alias
        return this.valid;
    }

    _showValidState() {
        if (this.valid == true) {
            domClass.remove(this[this.mandatoryNodeName], "mds-mandatory");
        } else {
            domClass.add(this[this.mandatoryNodeName], "mds-mandatory");
        }
        this._showMandatoryNotification(!this.valid);
    }

    _showMandatoryNotification(visible: any, infoText?: any) {


        if (this._mandatoryNotification == null) {
            this._mandatoryNotification = new MandatoryNotification();
            this._mandatoryNotification.placeAt(this[this.mandatoryNodeName], this.mandatoryNodePosition);
        }

        if (infoText) {
            this.mandatoryInfoText = infoText;
        } else {
            this.mandatoryInfoText = null;
        }

        if (this.mandatoryInfoText != null) {
            this._mandatoryNotification._setInfoTextAttr(this.mandatoryInfoText);
        }

        if (domStyle.get(this.domNode, "display") == "none") { // wenn control selbst nicht sichtbar, dann auch keine mandatorynotification anhängen
            domStyle.set(this._mandatoryNotification.domNode, "display", "none");
            return;
        }

        domStyle.set(this._mandatoryNotification.domNode, "display", visible == true ? "" : "none");
    }

    _clearMandatoryNotifications() {
        if (this._mandatoryNotification) {
            domConstruct.destroy(this._mandatoryNotification.domNode);
            this._mandatoryNotification = null;
        }
    }

}

;
Object.assign(__C.prototype, {
  mandatory: false,
  valid: true,
  _mandatoryNotification: null,
  mandatoryNodeName: "domNode",
  mandatoryNodePosition: "after",
  mandatoryInfoText: null,
  dateOverMaxLimit: false,
  declaredClass: '_MandatoryMixin',
});
  return __C;
}
Object.assign(_MandatoryMixin, { __mdsMixinFactory: true, __mdsSpineBases: [] });
